export const defaultMarket = [
  'animal-type',
  'animal-info',
  'user-info',
  'auth-redirect',
  // 'mobile-phone',
  // 'mobile-phone-confirm',
  'post-signup',
];

export const usMarket = [
  'user-info',
  'auth-redirect',
  // 'mobile-phone',
  // 'mobile-phone-confirm',
  'post-signup',
];
